<template>
    <div class="p-2 rounded-lg">
        <div class="flex flex-col mb-2 px-4 text-center select-none">
            <slot name="header" :date="selectedDisplayDate">
                <h3 class="text-white w-full text-xl font-bold">
                    <span class="uppercase">Events Calendar</span> - {{ selectedDisplayDate.format('MMMM YYYY') }}
                </h3>
            </slot>
        </div>
        <div v-if="managedEvents.length > 0">
            <div v-for="(event, eventId) in managedEvents" :key="eventId" class="flex flex-row">
                <div class="flex items-center select-none">
                    <slot name="calendarDate" :event="event">
                        <div class="border border-white rounded w-12 py-2 m-2 text-white">
                            <div class="text-center text-lg font-bold">
                                {{ event.starts.format('DD') }}
                            </div>
                            <div class="text-center text-xs uppercase">
                                {{ event.starts.format('ddd') }}
                            </div>
                        </div>
                    </slot>
                </div>
                <div class="flex-grow flex items-center m-2 text-white">
                    <div class="flex flex-col">
                        <slot name="event" :event="event">
                            <div class="font-bold leading-normal">
                                {{ event.title }}
                            </div>
                            <div class="text-xs">
                                {{ event.location.display }} -
                                <span>
                                    {{ event.starts.format('h:mma') }} -
                                    {{ event.ends.format('h:mma')  }}
                                </span>
                            </div>
                        </slot>
                    </div>
                </div>
                <div class="flex-no-grow flex items-center">
                    <slot name="moreButton">
                        <a v-if="event.link" :href="event.link" target="_blank" class="no-underline cursor-pointer border border-white text-white p-2 m-2 md:px-6 rounded">
                            More
                        </a>
                    </slot>
                </div>
            </div>
        </div>
        <div v-else class="flex flex-col px-4 text-center items-center my-8 select-none">
            <slot name="noEvents" :date="selectedDisplayDate">
                <p class="text-white">There are currently no events this month.</p>
            </slot>
        </div>
        <!-- <div class="flex items-center mt-4">
            <slot name="calendarButton">
                <button type="button" class="flex-1 border border-white text-white p-2 m-2 rounded">
                    <i class="fas fa-calendar-alt"></i>
                    See Calendar
                </button>
            </slot>
        </div> -->
    </div>
</template>

<script>
import calendar from '@/mixins/Calendar'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'EventList',
  props: {
    eventsToDisplay: {
      type: Number,
      default: 3
    },
    month: {
      type: Date,
      default: () => { return moment().startOf('month').toDate() }
    }
  },
  mixins: [calendar],
  data () {
    return {
      selectedMonth: this.month
    }
  },
  computed: {
    managedEvents () {
      let events = _.sortBy(this.allEvents, 'scheduled_start_at')
      events = _.map(events, (event) => {
        event.starts = moment(event.scheduled_start_at)
        event.ends = moment(event.scheduled_end_at)
        return event
      })
      events = _.filter(events, (event) => {
        return event.starts.isSame(this.selectedMonth, 'month')
      })
      return _.slice(events, 0, this.eventsToDisplay)
    },
    selectedDisplayDate () {
      return moment(this.selectedMonth)
    }
  },
  created () {
    this.fetchCalendarEvents(
      moment().startOf('month'),
      moment().endOf('month')
    )
  }
}
</script>

<style scoped>
</style>
